module.exports = __webpack_public_path__ + "img/Weapon_164.48843178.png";